var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-box mt14" },
    [
      _c(
        "el-scrollbar",
        { staticStyle: { height: "100%" } },
        [
          _c("el-tree", {
            ref: "tree",
            attrs: {
              data: _vm.treeData,
              props: _vm.defaultProps,
              "highlight-current": true,
              "default-expanded-keys": [0],
              "expand-on-click-node": false,
              "icon-class": "el-icon-arrow-right",
              "node-key": "value",
            },
            on: { "node-click": _vm.handleClick },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var node = ref.node
                  var data = ref.data
                  return _c("div", { staticClass: "custom-tree-node" }, [
                    _c("span", { staticClass: "flex-box" }, [
                      _vm._v(
                        "\n          " + _vm._s(node.label) + "\n        "
                      ),
                    ]),
                  ])
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }